import { render, staticRenderFns } from "./AdminProductOrderQuotesView.vue?vue&type=template&id=5ef056bc"
import script from "./AdminProductOrderQuotesView.vue?vue&type=script&lang=ts"
export * from "./AdminProductOrderQuotesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports